import {Component} from "../../../gvf/js/component";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";
import {GvfService} from "../../../gvf/js/gvf-service";
import {UtilsService} from "../../js/utils-service";

export class WorkerEditionForm extends Component{
    constructor(scope,$root){
        super(scope,$root);
    }

    /**
     * Opens worker edition form
     * @param {string} id Worker id
     * @returns {Promise<boolean>}
     */
    openWorkerEditionForm(id){
        this.$root.toggleClass("is-menu-hidden",this.$root.data("keep-menu")!=1);
        this.$modal.addClass("is-loading");
        const data = {id:id};
        this.findMember("link").removeClass("is-selected");
        const fieldData = this.$root.data("field");
        const $formC = this.findMember("form-container");
        fieldData.from_menu = true;
        $formC.html("");
        return GvfService.endpoint(
            "/cp/worker/render-custom-object-edition-form",
            {data:data,fieldData:fieldData}
        ).then(
            (resp)=>{
                $formC.html(resp.html);
                const $innerForm = $formC.find('.js-custom-object-edit__form');
                $innerForm.submit(
                    (ev)=>{
                        ev.preventDefault();
                        const v = $innerForm.getValues();
                        $innerForm.checkRestrictions().then(
                            (isOk)=>{
                                if(isOk){
                                    GvfService.endpoint(
                                        "/cp/worker/submit-edition-form",
                                        {formData:v,fieldData:fieldData}
                                    ).then(
                                        (resp)=>{
                                            if(fieldData.multiple){
                                                this.$modal.data("sourceField").addValue(resp.data,false,fieldData.editPosition);
                                            }else{
                                                this.$modal.data("sourceField").setValue(resp.data);
                                            }
                                        }
                                    ).catch(
                                        (resp)=>{
                                            if(resp.hasOwnProperty("responseJSON") && resp.responseJSON.validation){
                                                $innerForm.applyValidationResponse(resp.responseJSON.validation);
                                            }else{
                                                UtilsService.alertEndpointResponse(resp);
                                            }
                                        }
                                    );
                                }
                            }
                        );
                    }
                );
                GvfUiService.init($formC);

                const $formVisibleFields = $innerForm.find(".js-form-field:visible");
                if($formVisibleFields.length>0){ //has visible fields
                    this.$modal.removeClass("has-only-menu");
                }else{ //auto submit form
                    $innerForm.submit();
                }
                return true;
            }
        ).catch(UtilsService.alertEndpointResponse).finally(
            ()=>{
                this.$modal.removeClass("is-loading");
            }
        );
    }

    searchMenu(q){
        this.$searchInput.val(q);
        //remove accents/diacritics and upper cases
        q = q.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
        this.$menuContent.toggleClass("has-search-results",q.length>0);
        this.$searchResults.html("");
        if(q.length>0){
            this.$root.find("[data-search]").each(
                (index,item)=>{
                    const name = $(item).data("search");
                    //remove accents/diacritics and upper cases
                    const itemSearch = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
                    if(itemSearch.indexOf(q)>-1){
                        const icon = $(item).data("icon");
                        const $link = $("<a />");
                        $link.attr("href","#");
                        $link.addClass(this.scope.replace(".js-","cp-")+"__search-result-item");
                        $link.data("id",$(item).data("id"));
                        $link.html("<i class='"+icon+"'></i> "+name);
                        this.$searchResults.append($link);
                        $link.width($link.width());
                        $link.click(
                            (ev)=>{
                                ev.preventDefault();
                                this.openWorkerEditionForm($(ev.currentTarget).data("id")).then(
                                    ()=>{
                                        this.searchMenu("");
                                    }
                                );
                            }
                        );
                    }
                }
            );
        }
    }

    ready(){
        this.$modal = this.$root.closest(".js-form-field-custom-object__modal");
        this.$modal.toggleClass("has-only-menu",this.$root.find("form").length==0);
        this.$menuContent = this.findMember("menu-content");
        this.$searchInput = this.findMember("search-input");
        this.$searchResults = this.findMember("search-results");
        this.findMember("link").click(
            (ev)=>{
                ev.preventDefault();
                $(ev.currentTarget).addClass("is-selected");
                const $link = $(ev.currentTarget);
                if($link.data("ref-id")){
                    const val = {ref:$link.data("ref-id")};
                    const fieldData = this.$root.data("field");
                    if(fieldData.multiple){
                        this.$modal.data("sourceField").addValue(val,false,fieldData.editPosition);
                    }else{
                        this.$modal.data("sourceField").setValue(val);
                    }
                }else{
                    this.openWorkerEditionForm($link.data("id"));
                }
            }
        );

        this.findMember("menu-toggle-button").click(
            (ev)=>{
                ev.preventDefault();
                this.searchMenu("");
                this.$root.removeClass("is-menu-hidden");
            }
        );

        this.$searchInput.keyup(
            (ev)=>{
                GvfService.delay(500,"workersearch").then(
                    ()=>{
                        this.searchMenu(this.$searchInput.val());
                    }
                );
            }
        );
    }
}

